import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  NEW_PASSWORD,
  NEW_PASSWORD_SUCCESS,
  NEW_PASSWORD_ERROR,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
  RESET_UPDATE_PASSWORD_ERROR,
} from "./actionTypes"

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  }
}

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}

export const newPassword = (user, history) => {
  return {
    type: NEW_PASSWORD,
    payload: { user, history },
  }
}

export const newPasswordSuccess = msg => {
  return {
    type: NEW_PASSWORD_SUCCESS,
    payload: msg,
  }
}

export const newPasswordError = error => {
  return {
    type: NEW_PASSWORD_ERROR,
    payload: error,
  }
}

export const updatePassword = (user) => {
  return {
    type: UPDATE_PASSWORD,
    payload: { user},
  }
}

export const updatePasswordSuccess = msg => {
  return {
    type: UPDATE_PASSWORD_SUCCESS,
    payload: msg,
  }
}

export const updatePasswordError = error => {
  return {
    type: UPDATE_PASSWORD_ERROR,
    payload: error,
  }
}

export const resetupdatePasswordError = error => {
  return {
    type: RESET_UPDATE_PASSWORD_ERROR,
    payload: error,
  }
}
